@import '../../../constants/spacing.module.less';

.body-content {
  padding: @space-16;
}

.textarea-container {
  position: relative;
}

.error-message {
  margin-top: @space-4;
}
